import ColorIconHelper from '@/helpers/colorIcon.helper'
import Button from '@components/buttons/button/button.component'
import User from '@interfaces/user.interface'
import { useCallback, useEffect, useState, useMemo } from 'react'
import DataLayerHelper from '@/helpers/data-layer.helper'

import './button-social-network.component.scoped.scss'

interface Props extends React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  disabled?: boolean
  loading?: boolean
  onClick?: () => void
  onHover?: (hover: boolean) => void
  size?: 'sm' | 'md' | 'lg' | 'xl'
  socialNetwork?: 'instagram' | 'facebook' | 'youtube' | 'twitter' | 'tiktok'
  width?: string
  user?: User
}

export default ({
  className = '',
  disabled = false,
  loading = false,
  onClick,
  onHover,
  size = 'md',
  socialNetwork = 'instagram',
  id,
  width,
  user,
}: Props) => {
  const [state, setState] = useState<{
    name: string
    color: string
    icon: string | string[]
  }>({
    name: 'Instagram',
    color: 'var(--instagram)',
    icon: 'instagram',
  })
  const [hover, setHover] = useState(false)
  const colorIconHelper = new ColorIconHelper()
  const dataLayerHelper = useMemo(() => new DataLayerHelper(), [])

  useEffect(() => {
    switch (socialNetwork) {
      case 'facebook':
        // TODO: Validação Meta remover
        if (user?.profileadditionalinfo?.email === 'hfyuoiakom_1634747033@tfbnw.net') {
          setState({
            name: 'Facebook (Instagram)',
            color: 'facebook',
            icon: ['facebook'],
          })
        } else {
          setState({
            name: 'Instagram / Facebook',
            color: 'instagram',
            icon: ['instagram', 'facebook'],
          })
        }
        break
      case 'youtube':
        setState({
          name: 'Youtube',
          color: 'youtube',
          icon: 'youtube',
        })
        break
      case 'twitter':
        setState({
          name: 'Twitter',
          color: 'x',
          icon: 'x-twitter',
        })
        break
      case 'tiktok':
        setState({
          name: 'TikTok',
          color: 'tiktok',
          icon: 'tiktok',
        })
        break
      default:
        setState({
          name: 'Instagram',
          color: 'instagram',
          icon: 'instagram',
        })
        break
    }
  }, [socialNetwork, user?.profileadditionalinfo?.email])

  const callHover = (hover: boolean) => {
    setHover(hover)
    if (onHover && typeof onHover === 'function') {
      onHover(hover)
    }
  }

  const handleClick = useCallback(() => {
    if (onClick && typeof onClick === 'function') {
      dataLayerHelper.sendToDataLayer({
        event: 'social_network_session',
        step: 'Escolha uma rede social',
        socialNetwork: socialNetwork === 'facebook' ? 'instagram' : socialNetwork,
        action: 'next',
        description: 'coleta click para conectar redes sociais',
      })

      if (['facebook', 'instagram'].includes(socialNetwork)) {
        window['dataLayer'].push({
          event: 'social_network_buttons',
          socialNetwork: socialNetwork === 'facebook' ? 'instagram' : socialNetwork,
          variation: window['gb'].isOn('button-facebook-connection') ? 'Btn Rosa' : 'Btn Azul',
          user: {
            id: user?.squidId,
          },
        })
      }
      onClick()
    }
  }, [onClick, socialNetwork, user?.squidId, dataLayerHelper])

  return (
    <Button
      disabled={disabled}
      loading={loading}
      onClick={handleClick}
      onHover={callHover}
      size={size}
      className={`${className} button-social-network `}
      id={id}
      color={state.color}
      width={width}
    >
      <div className="display-flex justify-content-center">
        {Array?.isArray(state?.icon) ? (
          <div style={{ flexShrink: 0 }}>
            {state?.icon?.map((icon, index) => (
              <i
                key={index}
                className={`fa-brands fa-${colorIconHelper.setIcon(icon)} mr-1 ${index === state?.icon?.length - 1 ? 'mr-3' : ''}`}
                style={{ fontSize: '22px', color: 'inherit' }}
              ></i>
            ))}
          </div>
        ) : null}
        {!Array.isArray(state?.icon) ? (
          <i className={`fa-brands fa-${colorIconHelper.setIcon(state?.icon)} mr-3`} style={{ fontSize: '22px', color: 'inherit' }}></i>
        ) : null}
        <span style={{ color: 'inherit', fontWeight: 'bold', flexShrink: 0 }} dangerouslySetInnerHTML={{ __html: state.name }} />
      </div>
    </Button>
  )
}
